import Radio from '../../../../Components/Radio/Radio'
import './PaymentModeView.css'
import { NavigationNode } from '../../Services/Navigation'
import ViewType from '../../Types/ViewType'
import { Configuration, ConfiguratorContext } from '../../Contexts/Configuration'
import PlanLayout from '../../Layouts/PlanLayout/PlanLayout'
import { useContext, useEffect, useState } from 'react'
import API from '../../Services/API'
import Plan from '../../Models/Plan'
import PaymentMode from '../../Models/PaymentMode'

const PaymentModeView = () => {
	let context = useContext(ConfiguratorContext)

	let [plan, setPlan] = useState<Plan | undefined>(undefined)
	let [paymentModes, setPaymentModes] = useState<PaymentMode[]>([])
	let [selectedMode, setSelectedMode] = useState(context.paymentMode)
	let [selectionError, setSelectionError] = useState("")

	context.validatePaymentModeView = () => {
		context.paymentMode = selectedMode
		let validSelection = selectedMode !== undefined
		setSelectionError(validSelection ? "" : "E' necessario selezionare una modalità di pagamento")
		return validSelection
	}

	var selectionChanged = context.options?.flatMap(x => [...x.selection].sort((a, b) => a[0] - b[0]).map(x => x[1])).join("")

	useEffect(() => {
		(async () => {
			let response = await API.getPaymentModes(context.isHomeUse ? 1 : 2)
			if (response.success) {
				setPaymentModes(response.data)
			}
		})()
		return () => { }
	}, [])

	useEffect(() => {
		context.paymentMode = selectedMode
		return () => { }
	}, [selectedMode])

	useEffect(() => {
		(async () => {
			let m = []
			for (var d of context.options ?? []) {
				m.push({ id: d.parentId, products: [...d.selection].filter(x => x[1]).map(x => x[0]) })
			}
			let p = await API.getPlanAsync(context.selectedOffer!.id, {
				number_portability: context.keepNumber,
				wifi_consultancy: context.wifiCoverageCheck,
				payment_type: context.paymentType != undefined ? context.paymentType.name : '',
				payment_mode: context.paymentMode != undefined ? context.paymentMode.name : '',
				customer_type_id: context.isHomeUse ? 1 : 2,
				data: m
			})
			if (p.success) {
				setPlan(p.data)
			}
		})()
		return () => { }
	}, [context.keepNumber, context.paymentMode, context.wifiCoverageCheck, context.selectedOffer, context.options, selectionChanged, selectedMode])

	function getDiscountDiv(percentage: number) {
		if (percentage > 0) {
			return (
				<div className='payment-mode-discount'>
					Sconto del {percentage}%
				</div>
			)
		}
	}

	return (
		<PlanLayout plan={plan}>
			<div className='payment-mode-container'>
				<div className='payment-mode-title'>Scelta modalità di pagamento</div>
				<div className='payment-mode-radio-container'>
					{paymentModes.map(x =>
						<div className="payment-mode-element" >
							<div className='payment-mode-radio'>
								<Radio key={x.id} checked={selectedMode !== undefined && selectedMode.id === x.id} onChange={() => setSelectedMode(x)} />
								{x.name}
							</div>
							{getDiscountDiv(x.percentage_discount)}
						</div>
					)}
				</div>
				<div className='label-error'>{selectionError}</div>
			</div>
		</PlanLayout>
	)
}

const PaymentModeNode: NavigationNode = {
	content: () => <PaymentModeView />,
	next: (configuration) => ViewType.paymentType,
	previous: (context: Configuration) => context.voipSelected ? ViewType.portabilityNumber : ViewType.optionsView,
	percentage: 81
}

export default PaymentModeNode
